<template>
	<div>
		<v-select
			v-model="selected"
			:options="optionsForCountries"
			:disabled="disabled"
			label="text"
			multiple
			:clearable="false"
			@option:selected="handleCountryChange"
			:class="{ 'is-invalid': error }"
		/>
		<div v-if="error" class="invalid-feedback">
			{{ FormMSG(2, 'Country is required') }}
		</div>
	</div>
</template>

<script>
import { getObjectFromValue } from '@/shared/utils';
import languageMessages from '@/mixins/languageMessages';
import { isNil, noTilde } from '@/shared/utils';
import { CARBON_CLAP_COUNTRIES_MENU, COUNTRIES_MENU } from '@/shared/constants';

export default {
	name: 'CountrySelectorComponent',
	mixins: [languageMessages],
	props: {
		customId: {
			type: String,
			required: false,
			default: 'country-selector'
		},
		countrySelected: {
			type: Number | String,
			required: false,
			default: null
		},
		error: {
			type: Boolean,
			required: false,
			default: false
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false
		},
		forCarbonClap: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	computed: {
		/**
		 * @return {Array}
		 */
		optionsForCountries() {
			let options = this.FormMenu(this.forCarbonClap ? CARBON_CLAP_COUNTRIES_MENU : COUNTRIES_MENU);
			options.sort((a, b) => {
				if (noTilde(a.text) < noTilde(b.text)) {
					return -1;
				}
				if (noTilde(a.text) > noTilde(b.text)) {
					return 1;
				}

				return 0;
			});

			return options;
		},

		/**
		 * @return {Array}
		 */
		optionsForCountryCode() {
			return this.FormMenu(9);
		}
	},
	data() {
		return {
			selected: 16965
		};
	},
	mounted() {
		this.selectCountry(this.countrySelected);
	},
	methods: {
		/**
		 * @param {Number} countryKey
		 */
		handleCountryChange(countryKey) {
			this.$emit('change', {
				key: countryKey
			});
		},
		selectCountry(value) {
			if (typeof value === 'string') {
				const selectedIds = value
					.toString()
					.split(',')
					.map((id) => Number(id))
					.filter((id) => !isNaN(id));

				const selectedCountry = this.optionsForCountries.filter((option) => selectedIds.includes(option.value));

				this.selected = selectedCountry;
			} else {
				this.selected = value;
			}
		}
	},
	watch: {
		countrySelected: {
			handler(value) {
				if (!isNil(value)) {
					this.selectCountry(value);
				}
			},
			deep: true,
			immediate: true
		}
	}
};
</script>
